import { deepFreeze } from '../../utils/misc_utils';

export const OrderSuccessMessageEnum = deepFreeze({
    CREATE_THEFT_REGISTRY: 'Pomyślnie utworzono kartotekę',
    UPDATE_THEFT_REGISTRY_STATUS: 'Pomyślnie zaktualizowano status kartoteki',
    CREATE_THEFT_REGISTRY_SMS: 'Pomyślnie wysłano wiadomość sms',
    CANCEL_THEFT_REGISTRY: 'Pomyślnie anulowano kradzież',
    RETURN_ORDER: 'Pomyślnie utworzono zwrot',
    CREATE_POD_ORDER: 'Pomyślnie utworzono zamówienie',
    UPDATE_POD_ORDER_STATUS: 'Pomyślnie zaktualizowano status zamówienia',
});

export const OrderErrorMessageEnum = deepFreeze({
    GET_CART_EVENTS: 'Pobranie zdarzeń koszyka nie powiodło się',
    GET_THEFT_REGISTRIES: 'Pobranie kartotek nie powiodło się',
    GET_THEFT_REGISTRIES_FOR_STORE: 'Pobranie kartotek nie powiodło się',
    GET_THEFT_REGISTRY: 'Pobranie kartoteki nie powiodło się',
    GET_POD_ORDERS: 'Pobranie zamówień nie powiodło się',
    GET_ORDERS: 'Pobranie zamówień nie powiodło się',
    GET_RESERVATION_ORDER: 'Pobranie zamówienia nie powiodło się',
    CREATE_THEFT_REGISTRY: 'Utworzenie kartoteki nie powiodło się',
    UPDATE_THEFT_REGISTRY_STATUS: 'Aktualizacja statusu kartoteki nie powiodła się',
    CREATE_THEFT_REGISTRY_SMS: 'Wysłanie wiadomości sms nie powiodło się',
    CANCEL_THEFT_REGISTRY: 'Anulowanie kradzieży nie powiodło się',
    RETURN_ORDER: 'Utworzenie zwrotu nie powiodło się',
    CREATE_POD_ORDER: 'Utworzenie zamówienia nie powiodło się',
    UPDATE_POD_ORDER_STATUS: 'Aktualizacja statusu zamówienia nie powiodła się',
    GET_SALES_STATS: 'Pobranie statystyk sprzedaży nie powiodło się',
});

const OrderServerErrorMessageEnum = deepFreeze({
    INVALID_ORDER_STATUS: {
        message: 'Niepoprawny status zakupu',
        errorCode: '400.27'
    },
    INCORRECT_RETURN_REASON: {
        message: 'Niepoprawny powód zwrotu',
        errorCode: '400.30'
    },
    RETURN_ORDER_POSITIONS_CANNOT_BE_EMPTY: {
        message: 'Brak pozycji do zwrotu',
        errorCode: '400.31'
    },
    POSITION_ALREADY_CANCELLED: {
        message: 'Pozycja została już zwrócona',
        errorCode: '400.33'
    },
    INVALID_STATS_DATE_RANGE: {
        message: 'Niepoprawny zakres dat (maksymalnie 366 dni)',
        errorCode: '400.37'
    },
    INVALID_STATS_PARAMETER: {
        message: 'Niepoprawny parametr statystyk',
        errorCode: '400.38'
    },
});

export const getOrderErrorMessage = (message, defaultErrorMessage) => {
    for (let key in OrderServerErrorMessageEnum) {
        if (OrderServerErrorMessageEnum.hasOwnProperty(key)) {
            if (message?.substring(0, message?.indexOf(' ')) === OrderServerErrorMessageEnum[key].errorCode) {
                return OrderServerErrorMessageEnum[key].message;
            }
        }
    }

    return defaultErrorMessage;
};
